export default "__VITE_ASSET__S5UUkN4a__"